import { render, staticRenderFns } from "./CustomIcons.vue?vue&type=template&id=8604b972&"
import script from "./CustomIcons.vue?vue&type=script&lang=js&"
export * from "./CustomIcons.vue?vue&type=script&lang=js&"
import style0 from "./CustomIcons.vue?vue&type=style&index=0&id=8604b972&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports